import { listInsurances } from "../../services/librariesCatalogService";

const SUGGEST_LIMIT = 12;

export async function searchInsuranceCatalog(query = "", { signal } = {}) {
  const trimmed = String(query || "").trim();
  const res = await listInsurances(
    {
      status: "Active",
      limit: SUGGEST_LIMIT,
      sortBy: "insuranceName",
      sortOrder: "asc",
      nameOnly: true,
      ...(trimmed ? { search: trimmed } : {}),
    },
    { signal },
  );
  return res?.items || [];
}

export function getInsuranceOptionLabel(row) {
  if (!row) return "";
  return row.insuranceName || "";
}

export function getInsuranceOptionKey(row) {
  if (!row?.id) return getInsuranceOptionLabel(row);
  return `insurance-${row.id}`;
}

export function getInsuranceOptionSubtitle(row) {
  if (!row) return "";
  const parts = [row.category, row.insuranceCode].filter(Boolean);
  return parts.join(" · ");
}
